import React, { createContext, useContext, useReducer } from 'react';

const DataContext = createContext();

const dataReducer = (state = loadFromLocalStore(), action) => {
  let newState = {}
  switch (action.type) {
    case 'UPDATE_PACKAGE':
      newState = { ...state, selectedPackage: action.payload };
      saveToLocalStore(newState)
      return newState
    case 'UPDATE_BUSINESS_NAME':
      newState = { ...state, businessName: action.payload };
      saveToLocalStore(newState)
      return newState
    case 'UPDATE_SELECTED_DESIGNATOR':
      newState = { ...state, selectedDesignator: action.payload };
      saveToLocalStore(newState)
      return newState
    case 'UPDATE_BUSINESS_LOCATION':
      newState = { ...state, businessLocation: action.payload };
      saveToLocalStore(newState)
      return newState
    case 'UPDATE_FULLNAME':
      newState = { ...state, fullName: action.payload };
      saveToLocalStore(newState)
      return newState
    case 'UPDATE_EMAILADDRESS':
      newState = { ...state, emailAddress: action.payload };
      saveToLocalStore(newState)
      return newState
    case 'UPDATE_SELECTED_CATAGORY':
      newState = { ...state, selectCatagory: action.payload };
      saveToLocalStore(newState)
      return newState
    case 'UPDATE_FIRSTNAME':
      newState = { ...state, firstName: action.payload };
      saveToLocalStore(newState)
      return newState
    case 'UPDATE_LASTNAME':
      newState = { ...state, lastName: action.payload };
      saveToLocalStore(newState)
      return newState
    case 'UPDATE_OWNERTYPE':
      newState = { ...state, ownerType: action.payload };
      saveToLocalStore(newState)
      return newState
    case 'UPDATE_EMAIL':
      newState = { ...state, email: action.payload };
      saveToLocalStore(newState)
      return newState
    case 'UPDATE_STATE':
      newState = { ...state, state: action.payload };
      saveToLocalStore(newState)
      return newState
    default:
      console.log(state)
      // saveToLocalStore(state) 
      return state;
  }
  saveToLocalStore(newState);
  return newState;
};

const saveToLocalStore = (payload) => {
  console.log(payload, "ABC")
  localStorage.setItem('LLC', JSON.stringify(payload))

}


const loadFromLocalStore = () => {
  console.log("loadingFromLocalstore")
  // const fullNameMember = firstName + " " + lastName
  const EMPTY_DATA = {
    selectedPackage: '',
    businessName: '',
    selectedDesignator: '',
    businessLocation: {
      street: '',
      city: '',
      stateCode: '',
      zipCode: '',
    },
    fullName: '',
    emailAddress: '',
    selectCatagory: '',
    firstName: '',
    lastName: '',
    ownerType: '',
    email: ''
  }
  try {
    const localState = localStorage.getItem('LLC')
    if (localState == null) {
      return EMPTY_DATA
    }
    console.log(localState)
    return JSON.parse(localState)
  }
  catch (error) {
    return EMPTY_DATA
  }
}

const DataProvider = ({ children }) => {
  const [state, dispatch] = useReducer(dataReducer, loadFromLocalStore());

  return (
    <DataContext.Provider value={{ state, dispatch }}>
      {children}
    </DataContext.Provider>
  );
};

const useData = () => {
  const context = useContext(DataContext);
  if (!context) {
    throw new Error('useData must be used within a DataProvider');
  }
  return context;
};

export { DataProvider, useData };